export class DownloadPdfDocument {
  constructor(public documentId: string, public year: number) { }
  static readonly type = '[Inscription] DownloadPdfDocument';
}

export class LoadYearsInfos {
  static readonly type = '[Inscription] LoadYearsInfos';
  constructor() { }
}